<div class="main grid grid-cards-container gap-1.25">
  <div class="table-fms width-unset left-container">
    <table>
      <thead>
        <tr>
          <th>Portfolio</th>
          <th>
            <div class="flex flex-col gap-0.15625">
              <span># of companies</span>
              <span class="caption-3 bold500 black-9">% of total</span>
            </div>
          </th>
          <th>
            <div class="flex flex-col gap-0.15625">
              <span>Investment</span>
              <span class="caption-3 bold500 black-9">% of total</span>
            </div>
          </th>
          <th>
            <div class="flex flex-col gap-0.15625">
              <span>Proceeds</span>
              <span class="caption-3 bold500 black-9">% of total</span>
            </div>
          </th>
          <th>
            <div class="flex flex-col gap-0.15625">
              <span>Gain/(loss)</span>
              <span class="caption-3 bold500 black-9">% of total</span>
            </div>
          </th>
          <th>MOIC</th>
        </tr>
      </thead>
      <tbody>
        @for (metric of [analyticsData.atGain, analyticsData.atLoss, analyticsData.writeOff, analyticsData.total]; track $index) {
          <tr [class.total] = "metric === analyticsData.total">
            <td>{{metric.name}}</td>
            <td>
              <div class="flex flex-col">
                <span>{{metric.companiesNumber}}</span>
                <span class="caption-3 bold400 black-9">
                  {{metric.companiesNumber / analyticsData.total.companiesNumber * 100 | switcherDashBraces: 1 : 2 : null : '': '%' }}
                </span>
              </div>
            </td>
            <td>
              <div class="flex flex-col">
                <span>{{metric.investment | switcherDashBraces: 1 : 0 }}</span>
                <span class="caption-3 bold400 black-9">
                  {{metric.investment / analyticsData.total.investment * 100 | switcherDashBraces: 1 : 2 : null : '': '%' }}
                </span>
              </div>
            </td>
            <td>
              <div class="flex flex-col">
                <span>{{metric.proceeds | switcherDashBraces: 1 : 0 }}</span>
                <span class="caption-3 bold400 black-9">
                  {{metric.proceeds / analyticsData.total.proceeds * 100 | switcherDashBraces: 1 : 2 : null : '': '%' }}
                </span>
              </div>
            </td>
            <td>
              <div class="flex flex-col">
                <span>{{metric.gain | switcherDashBraces: 1 : 0 }}</span>
                <span class="caption-3 bold400 black-9">
                  {{metric.gain / analyticsData.total.gain * 100 | switcherDashBraces: 1 : 2 : null : '': '%' }}
                </span>
              </div>
            </td>
            <td>{{metric.moic | switcherDashBraces: 1 : 2 : null : 'x' }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="grid grid-cols-3 right-container gap-0.625">
    <div class="card flex flex-col">
      <span class="caption-2 bold600">Initial investment</span>
      <div class="flex items-end justify-between">
        <span data-qa="fs-analytics-cards-initial-investment" class="font-3 bold600">
          {{analyticsData.analyticsCards.initialInvestment | fpModifyValue: '' : '' : 1}}
        </span>
        <span data-qa="fs-analytics-cards-initial-investment-pcnt" class="font-4 bold600 black-8">
          {{ analyticsData.analyticsCards.initialInvestment / analyticsData.analyticsCards.totalInvestment * 100 | fpModifyValue: '' : '%' : 1}}
        </span>
      </div>
    </div>

    <div class="card flex flex-col">
      <span class="caption-2 bold600">Follow-on investment</span>
      <div class="flex items-end justify-between">
        <span data-qa="fs-analytics-cards-follow-on-investment" class="font-3 bold600">
          {{analyticsData.analyticsCards.followOnInvestment | fpModifyValue: '' : '' : 1}}
        </span>
        <span data-qa="fs-analytics-cards-follow-on-investment-pcnt" class="font-4 bold600 black-8">
          {{ analyticsData.analyticsCards.followOnInvestment / analyticsData.analyticsCards.totalInvestment * 100 | fpModifyValue: '' : '%' : 1}}
        </span>
      </div>
    </div>

    <div class="card flex flex-col">
      <span class="caption-2 bold600">Total investment</span>
      <span data-qa="fs-analytics-cards-total-investment" class="font-3 bold600">
        {{analyticsData.analyticsCards.totalInvestment | fpModifyValue: '' : '' : 1}}
      </span>
    </div>

    <div class="card flex flex-col">
      <span class="caption-2 bold600">Initial rounds</span>
      <div class="flex items-end justify-between">
        <span data-qa="fs-analytics-cards-initial-rounds" class="font-3 bold600">
          {{analyticsData.analyticsCards.initialRoundsNumber | fpModifyValue: '' : '' : 0}}
        </span>
        <span  data-qa="fs-analytics-cards-initial-rounds-pcnt" class="font-4 bold600 black-8">
          {{ analyticsData.analyticsCards.initialRoundsNumber / analyticsData.analyticsCards.roundsNumber * 100 | fpModifyValue: '' : '%' : 1}}
        </span>
      </div>
    </div>

    <div class="card flex flex-col">
      <span class="caption-2 bold600">Follow-on rounds</span>
      <div class="flex items-end justify-between">
        <span data-qa="fs-analytics-cards-follow-on-rounds" class="font-3 bold600">
          {{analyticsData.analyticsCards.followOnRoundsNumber | fpModifyValue: '' : '' : 0}}
        </span>
        <span data-qa="fs-analytics-cards-follow-on-rounds-pcnt" class="font-4 bold600 black-8">
          {{ analyticsData.analyticsCards.followOnRoundsNumber / analyticsData.analyticsCards.roundsNumber * 100 | fpModifyValue: '' : '%' : 1}}
        </span>
      </div>    </div>

      <div class="card flex flex-col">
        <span class="caption-2 bold600">Rounds participated</span>
        <span data-qa="fs-analytics-cards-rounds-participated" class="font-3 bold600">
          {{analyticsData.analyticsCards.roundsNumber | fpModifyValue: '' : '' : 0}}
        </span>
      </div>

      <div class="card flex flex-col">
        <span class="caption-2 bold600">Avg. initial investment</span>
        <div class="flex items-end justify-between">
          <span data-qa="fs-analytics-cards-avg-initial-investment" class="font-3 bold600">
            {{analyticsData.analyticsCards.avgInitialInv | fpModifyValue: '' : '' : 1}}
          </span>
          @if (analyticsData.analyticsCards.initialCompaniesNumber ) {
            <span data-qa="fs-analytics-cards-avg-initial-investment-comp" class="font-4 bold600 black-8">
              {{analyticsData.analyticsCards.initialCompaniesNumber  | fpModifyValue: '' : '' : 0}} comp.
            </span>
          }
        </div>
      </div>

      <div class="card flex flex-col">
        <span class="caption-2 bold600">Avg. follow-on investment</span>
        <div class="flex items-end justify-between">
          <span data-qa="fs-analytics-cards-avg-follow-on-investment" class="font-3 bold600">
            {{analyticsData.analyticsCards.avgFollowOnInv | fpModifyValue: '' : '' : 1}}
          </span>
          @if(analyticsData.analyticsCards.followOnCompaniesNumber) {
            <span data-qa="fs-analytics-cards-avg-follow-on-investment-comp" class="font-4 bold600 black-8">
              {{analyticsData.analyticsCards.followOnCompaniesNumber   | fpModifyValue: '' : '' : 0}} comp.
            </span>
          }
        </div>
      </div>

      <div class="card flex flex-col">
        <span class="caption-2 bold600">Avg. total investment</span>
        <span data-qa="fs-analytics-cards-avg-total-investment" class="font-3 bold600">
          {{analyticsData.analyticsCards.avgTotalInv | fpModifyValue: '' : '' : 1}}
        </span>
      </div>

      <div class="card flex flex-col">
        <span class="caption-2 bold600">Avg. initial holding</span>
        <span data-qa="fs-analytics-cards-avg-initial-holding" class="font-3 bold600">
          {{analyticsData.analyticsCards.avgInitialHolding * 100 | fpModifyValue: '' : '%' : 2}}
        </span>
      </div>

      <div class="card flex flex-col">
        <span class="caption-2 bold600">Avg. holding at exit</span>
        <span data-qa="fs-analytics-cards-avg-holding-at-exit" class="font-3 bold600">
          {{analyticsData.analyticsCards.avgExitHolding * 100 | fpModifyValue: '' : '%' : 2}}
        </span>
      </div>

      <div class="card flex flex-col">
        <span class="caption-2 bold600">Holding dilution (Init. to Exit)</span>
        <span data-qa="fs-analytics-cards-holding-dilution" class="font-3 bold600">
          {{analyticsData.analyticsCards.holdingDilution * 100 | fpModifyValue: '' : '%' : 2}}
        </span>
      </div>
    </div>
  </div>
